import LeftImageArea from '../components/LeftImageArea';
import Support from '../components/Support';
import '../components/registration.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="d-lg-flex half">
      <div className="contents order-md-2 form-area">
        <div className="container">
          <div className="row align-items-center justify-content-center h-full">
            {children}
          </div>
          <div className="content-center">
            <span className="float-right font-italic for-help">
              For Help:
              <i className="fas fa-phone-alt" style={{ fontSize: '14px' }}></i>
              <span>01335-134373</span>
            </span>
          </div>
        </div>
      </div>
      <LeftImageArea />
    </div>
  );
};

export default AuthLayout;
